var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.91,
    height: 7.248,
    viewBox: "0 0 12.91 7.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.91) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.016,5.875,1.372.232a.817.817,0,0,0-1.14,0,.817.817,0,0,0,0,1.14L5.315,6.455.232,11.538a.817.817,0,0,0,0,1.14.817.817,0,0,0,1.14,0L7.016,7.016A.817.817,0,0,0,7.016,5.875Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpArrow);
export default __webpack_public_path__ + "static/media/help_arrow.086dfbfa3d2ec2bf38d96d9224c5027d.svg";
export { ForwardRef as ReactComponent };